import type { AISetting } from '@repo/api-codegen';

export const isAiBindDisabled = (
	bindType: string,
	aiSettings: AISetting[],
	aiSettingId: string
): boolean => {
	const boundAttributes = [];

	if (
		aiSettings.some(
			(aiSetting) => aiSetting.bind_description && aiSetting.id !== aiSettingId
		)
	) {
		boundAttributes.push('description');
	}
	if (
		aiSettings.some(
			(aiSetting) => aiSetting.bind_definition && aiSetting.id !== aiSettingId
		)
	) {
		boundAttributes.push('documentation');
	}
	if (
		aiSettings.some(
			(aiSetting) => aiSetting.bind_owners && aiSetting.id !== aiSettingId
		)
	) {
		boundAttributes.push('owners');
	}
	if (
		aiSettings.some(
			(aiSetting) => aiSetting.bind_tags && aiSetting.id !== aiSettingId
		)
	) {
		boundAttributes.push('tags');
	}
	if (
		aiSettings.some(
			(aiSetting) => aiSetting.bind_pii && aiSetting.id !== aiSettingId
		)
	) {
		boundAttributes.push('pii');
	}

	return boundAttributes.includes(bindType);
};
